<template>
  <div class="col-md-12 p-0 master-list-page job-position-page">
    <!-- The Modal -->
    <div class="popup popup-sm" v-if="isEnablePopup">
      <div class="content">
        <small id="close-popup" @click="ClosePopup()"
          ><i class="ti ti-close"></i
        ></small>
        <h5>
          Master Job Position <br />
          <small>Please insert complete data.</small>
        </h5>
        <form @submit="submit">
          <div class="form-group">
            <label class="col-sm-12"
              >Job Title <small class="text-danger">*</small></label
            >
            <div class="col-sm-12">
              <input
                type="type"
                class="form-control"
                v-model="model_form.title"
                :true-value="1"
                :false-value="0"
              />
              <small class="text-danger" v-if="msg_error.title">{{
                msg_error.title[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-12">Job Description </label>
            <div class="col-sm-12">
              <textarea
                name=""
                class="form-control"
                v-model="model_form.description"
              ></textarea>
              <small class="text-danger" v-if="msg_error.description">{{
                msg_error.description[0]
              }}</small>
            </div>
          </div>
          <hr />
          <div class="form-group">
            <label class="col-sm-12">Mobile Position</label>
            <div class="col-sm-12">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="model_form.is_mobile"
                  true-value="1"
                  false-value="0"
                />
                <span></span> Is Mobile (Skip GPS, Require Photo)
              </label>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-12 text-center">
              <button class="btn btn-execute btn-primary">Save Data</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="card list-hero">
      <div class="card-body hero-content">
        <div>
          <span class="hero-eyebrow">Organization Structure</span>
          <h4>Job Position</h4>
          <p>Kelola jabatan, deskripsi pekerjaan, dan akses mobile.</p>
        </div>
        <div class="hero-total">
          <i class="ti ti-id-badge"></i>
          <div><strong>{{ data_model.total | formatPrice }}</strong><span>Positions</span></div>
        </div>
      </div>
    </div>

    <div class="card modern-list-card">
      <div class="card-body modern-list-body">
        <div class="table-header modern-list-header">
          <h5>
            Master Data <br />
            <small
              >Total Records :
              <b>{{ data_model.total | formatPrice }}</b></small
            >
          </h5>
          <div class="group-search pull-right modern-actions">
            <a class="btn icon-action" title="Refresh data" @click="tableRefresh()"
              ><i class="ti ti-reload"></i
            ></a>
            <a class="btn icon-action" title="Buka pencarian" @click="isActiveSearch()"
              ><i
                :class="isEnableTools == false ? 'ti ti-search' : 'ti ti-close'"
              ></i
            ></a>
            <div class="select" v-if="isEnableTools">
              <select v-model="meta_data.skey" @change="meta_data.sval = ''">
                <option value="">-- Choose Field --</option>
                <option value="title">Job Title</option>
                <option value="description">Description</option>
              </select>
            </div>
            <div class="group" v-if="isEnableTools">
              <input
                type="date"
                v-model="meta_data.sval"
                v-if="
                  meta_data.skey == 'created_at' ||
                  meta_data.skey == 'updated_at'
                "
              />
              <input
                type="text"
                v-model="meta_data.sval"
                placeholder="Enter Keyword ...."
                v-else
              />
              <a class="btn" @click="tableSearch()"> SEARCH DATA </a>
            </div>
            <a
              href="javascript:;"
              @click="tableCreateData()"
              class="btn btn-primary"
              v-if="$store.state.app.access.includes('insert')"
              ><i class="ti ti-plus"></i> Create New
            </a>
          </div>
        </div>
        <div class="table-cover modern-table-wrapper">
          <table class="table table-hover modern-table">
            <thead>
              <tr>
                <th
                  width="70"
                  class="no-filter text-center"
                  v-if="JSON.parse($store.state.app.access).length > 1"
                >
                  Action
                </th>
                <th
                  :class="meta_data.okey == 'title' ? 'active' : ''"
                  v-on:click="tableOrdering('title')"
                >
                  Title Name
                </th>
                <th
                  :class="meta_data.okey == 'description' ? 'active' : ''"
                  v-on:click="tableOrdering('description')"
                >
                  Description
                </th>
                <th>Mobile</th>
                <th
                  :class="meta_data.okey == 'created_at' ? 'active' : ''"
                  v-on:click="tableOrdering('created_at')"
                >
                  Created Date
                </th>
                <th
                  :class="meta_data.okey == 'updated_at' ? 'active' : ''"
                  v-on:click="tableOrdering('updated_at')"
                >
                  Updated Date
                </th>
              </tr>
            </thead>
            <tbody v-if="data_model.total > 0">
              <tr v-for="(items, idx) in data_model.data" :key="idx">
                <td v-if="JSON.parse($store.state.app.access).length > 1">
                  <div class="tools">
                    <a href="javascript:;">Tools</a>
                    <ul>
                      <li v-if="$store.state.app.access.includes('update')">
                        <a href="javascript:;" @click="tableUpdate(idx)"
                          ><i class="text-success ti ti-pencil"></i> Edit</a
                        >
                      </li>
                      <li v-if="$store.state.app.access.includes('delete')">
                        <a href="javascript:;" @click="tableRemove(items.id)"
                          ><i class="text-danger ti ti-trash"></i> Remove</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
                <td width="150">{{ items.title }}</td>
                <td width="500">{{ items.description }}</td>
                <td width="100">
                  <span v-if="items.is_mobile == 1" class="badge badge-success">
                    Mobile
                  </span>
                  <span v-else class="badge badge-secondary"> Non Mobile </span>
                </td>

                <td>{{ items.created_at | moment("DD/MM/YYYY") }}</td>
                <td>{{ items.updated_at | moment("DD/MM/YYYY") }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">
                  <div class="no-data" v-if="!$store.state.loading.status">
                    Sorry, data is not available
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination modern-footer">
          <small class="info"
            ><i class="ti ti-split-h"></i> Scroll horizontal to view
            data.</small
          >
          <paginate
            :page-count="parseInt(data_model.last_page)"
            :click-handler="tableQuery"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import SelectBranch from "../../Branch/@SelectBranch";

export default {
  data() {
    return {
      isRoot: false,
      isEnableTools: false,
      isEnableOrder: false,
      isEnablePopup: false,

      model_form: {},
      mode_form: "",
      meta_url: "job_position",
      meta_data: {
        okey: "created_at",
        oval: "desc",
        wkey: "",
        wval: "",
        skey: "",
        sval: "",
      },
      meta_filter: { id_branch: "all" },
    };
  },
  components: {
    SelectBranch,
  },
  computed: {
    ...mapState("crud", {
      data_model: (state) => state.data_model,
      msg_error: (state) => state.error,
    }),
  },
  created() {
    // filter branch
    if (localStorage.getItem("userPrivilegesName") !== "root") {
      this.meta_filter.id_branch = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }

    this.tableQuery();
  },
  methods: {
    isActiveSearch() {
      this.isEnableTools = !this.isEnableTools;
      if (this.isEnableTools) this.meta_data.sval = "";
    },
    ClosePopup() {
      this.tableQuery();
      this.isEnablePopup = false;
    },
    tableSearch() {
      if (this.meta_data.skey == "") {
        alert("🙏, Please choose target field");
        return;
      }
      if (this.meta_data.sval == "") {
        alert("🙏, Please enter the keyword");
        return;
      }
      this.tableQuery();
    },
    tableOrdering(key) {
      this.isEnableOrder = !this.isEnableOrder;
      this.meta_data.okey = key;
      this.meta_data.oval = this.isEnableOrder ? "ASC" : "DESC";
      this.tableQuery(this.page);
    },
    tableQuery(pageNum) {
      this.page = pageNum;
      let data = {
        url: this.meta_url + "/data",
        offset: this.page,
        search: { key: this.meta_data.skey, value: this.meta_data.sval },
        order: { key: this.meta_data.okey, value: this.meta_data.oval },
        where: { key: this.meta_data.wkey, value: this.meta_data.wval },
      };

      this.$store.state.loading.msg = "Processing Fetching Data...";
      this.$store.state.loading.status = true;
      this.$store.dispatch("crud/getData", data);
    },
    tableRefresh() {
      this.meta_data.skey = "";
      this.meta_data.sval = "";
      this.$store.state.loading.msg = "Refreshing Data...";
      this.$store.state.loading.status = true;
      this.$store.dispatch("crud/getData", { url: this.meta_url + "/data" });
    },
    tableCreateData() {
      this.model_form = {};
      this.mode_form = "store";
      this.isEnablePopup = true;
    },
    tableUpdate(idx) {
      this.model_form = {};
      this.mode_form = "update";
      this.model_form = { ...this.data_model.data[idx] };

      // Pastikan boolean/number sinkron
      this.model_form.is_mobile = this.model_form.is_mobile == 1 ? 1 : 0;

      this.isEnablePopup = true;
    },
    async tableRemove(id) {
      if (confirm("Are you sure want to remove this data ?")) {
        this.$store.state.loading.msg = "Processing Remove Data...";
        this.$store.state.loading.status = true;

        let data = { url: this.meta_url + "/destroy/" + id };
        let res = await this.$store.dispatch("crud/deleteData", data);
        if (res && res.result == "ok") {
          this.$store.state.alert.status = true;
          this.$store.state.alert.msg = res.msg;
          this.tableQuery();
        }
      }
    },

    async submit(e) {
      e.preventDefault();

      if (this.mode_form == "store") {
        this.$store.state.loading.msg = "Processing Submit Data...";
        this.$store.state.loading.status = true;

        // branch station
        this.model_form.id_branch = localStorage.getItem("userBranchId");

        let data = {
          url: this.meta_url + "/store",
          form_data: this.model_form,
        };
        let res = await this.$store.dispatch("crud/storeData", data);
        if (res && res.result == "ok") {
          this.isEnablePopup = false;
          this.tableQuery();
          this.$store.dispatch("crud/normalize");
        }
      }

      if (this.mode_form == "update") {
        this.$store.state.loading.msg = "Processing Update Data...";
        this.$store.state.loading.status = true;

        let data = {
          url: this.meta_url + "/update/" + this.model_form.id,
          form_data: this.model_form,
        };
        let res = await this.$store.dispatch("crud/updateData", data);
        if (res && res.result == "ok") {
          this.isEnablePopup = false;
          this.tableQuery();
          this.$store.dispatch("crud/normalize");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.master-list-page {
  padding-bottom: 30px;
}

.list-hero { min-height: 150px; margin-bottom: 20px; color: #fff; overflow: hidden; border: 0; border-radius: 14px; background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%); box-shadow: 0 10px 25px rgba(45, 111, 145, .16); }
.hero-content { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 25px 28px; }
.hero-eyebrow { color: #a7f3d0; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase; }
.list-hero h4 { margin: 5px 0 6px; color: #fff; font-weight: 700; }
.list-hero p { margin: 0; color: rgba(255,255,255,.78); }
.hero-total { display: flex; align-items: center; min-width: 160px; padding: 12px 18px; border: 1px solid rgba(255,255,255,.22); border-radius: 12px; background: rgba(255,255,255,.12); }
.hero-total > i { margin-right: 13px; font-size: 26px; }
.hero-total strong, .hero-total span { display: block; }
.hero-total strong { font-size: 22px; line-height: 1.1; }
.hero-total span { margin-top: 2px; color: rgba(255,255,255,.75); font-size: 11px; }

.modern-list-card {
  overflow: visible;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(28, 45, 75, 0.07);
}

.modern-list-body {
  padding: 24px 26px;
}

.modern-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf0f4;

  h5 {
    margin: 0;
    color: #364152;
    font-weight: 700;
  }

  h5 small {
    display: inline-block;
    margin-top: 5px;
    color: #7a8492;
    font-weight: 400;
  }
}

.modern-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;

  .btn {
    min-height: 40px;
    border-radius: 8px;
  }

  .icon-action { display: inline-flex; align-items: center; justify-content: center; width: 40px; padding: 0; color: #1769aa; background: #e8f4ff; }

  .select select,
  .group input {
    min-height: 40px;
    border: 1px solid #dfe4ea;
    border-radius: 8px;
  }
}

.modern-table-wrapper {
  overflow-x: auto;
  margin-top: 16px;
  border: 1px solid #edf0f4;
  border-radius: 10px;
}

.modern-table {
  min-width: 900px;
  margin: 0;

  thead th {
    padding: 15px 13px;
    border-top: 0;
    border-bottom: 1px solid #dee4ea;
    color: #77808d;
    background: #fbfcfe;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.35px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  tbody td {
    padding: 15px 13px;
    border-color: #edf0f4;
    color: #364152;
    vertical-align: middle;
  }

  tbody tr:hover {
    background: #f8fbff;
  }
}

.modern-table .tools { position: relative; }
.modern-table .tools > a { display: inline-flex; align-items: center; justify-content: center; min-width: 72px; padding: 7px 12px; border-radius: 18px; color: #1769aa; background: #e8f4ff; font-size: 11px; font-weight: 700; text-decoration: none; }
.modern-table .tools > a::after { margin-left: 7px; content: "\25BE"; font-size: 9px; }
.modern-table .tools ul { overflow: hidden; min-width: 150px; border: 1px solid #e5eaf0; border-radius: 9px; box-shadow: 0 10px 28px rgba(28, 45, 75, .15); }
.modern-table .tools li a { display: block; padding: 10px 13px; color: #495568; background: #fff; }
.modern-table .tools li a:hover { color: #1769aa; background: #f2f8ff; }

.modern-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-top: 18px;
  color: #7a8492;
}

@media (max-width: 767px) {
  .hero-content { align-items: stretch; flex-direction: column; padding: 22px 20px; }
  .hero-total { margin-top: 4px; }
  .modern-list-body {
    padding: 18px 14px;
  }

  .modern-list-header,
  .modern-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .modern-actions {
    justify-content: flex-start;
    width: 100%;

    .select,
    .group {
      width: 100%;
    }

    .select select,
    .group input {
      width: 100%;
    }
  }
}
</style>
